module.exports = __webpack_public_path__ + "img/bumpMap_4096.85c52f87.jpg";